import React, { ComponentProps } from "react";
import { Button } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";

type QuestionAndAnswerLinkProps = Partial<ComponentProps<typeof Button>> & {
  numberOfAnswers: number;
};

const QuestionAndAnswerLink = ({
  numberOfAnswers,
  className,
  ...rest
}: QuestionAndAnswerLinkProps) => {
  let text = "Ask a question";
  if (numberOfAnswers) {
    text = `${numberOfAnswers} answered question`;
    if (numberOfAnswers > 1) text += "s";
  }

  const handleAnswersLinkClick = () => {
    const elementToJumpTo = document?.getElementById("customerQA");

    elementToJumpTo?.focus();
    elementToJumpTo?.scrollIntoView();
  };

  return (
    <Button
      theme="wss"
      variant="plain"
      color="green"
      size="medium"
      data-testid="questions-and-answers-link"
      {...rest}
      onClick={handleAnswersLinkClick}
      className={cls(
        "text-xs border border-solid border-r-0 border-y-0 border-l-gray-300 px-2",
        className,
      )}
    >
      {text}
    </Button>
  );
};

export default QuestionAndAnswerLink;
